import { InsightsFilterState } from './useAssetsTableStore';

export enum InsightsAnalysisType {
  Fundamental = 'Fundamental',
  Technical = 'Technical',
  Macro = 'Macro',
  Related = 'RelatedAssets',
}

export const getDefaultInsightsFilterState = (selected: boolean) =>
  Object.values(InsightsAnalysisType).reduce((state, filterOpt) => {
    state[filterOpt] = selected;
    return state;
  }, {} as InsightsFilterState);
